import { render, staticRenderFns } from "./ProductCardExtension.vue?vue&type=template&id=257dec8a&scoped=true&"
import script from "./ProductCardExtension.vue?vue&type=script&lang=js&"
export * from "./ProductCardExtension.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardExtension.vue?vue&type=style&index=0&id=257dec8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257dec8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
